/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

type OfferedByProps = {|
    sellerName: string,
    className?: string,
|};

const OfferedBy = ({ sellerName, className }: OfferedByProps) => (
    <span className={className} data-tn="portfolio-row-dealer">
        <FormattedMessage
            id="dc.searchProductTile.offeredBy"
            defaultMessage={`Offered By {sellerName}`}
            values={{ sellerName }}
        />
    </span>
);

OfferedBy.defaultProps = {
    className: '',
};

export default OfferedBy;
